import React from "react";
import Modal from "../modal-new";
import submit from "submit-form";
import SvgIcon from "../SvgIcon";

const filterCategories = (arr, programId) =>
  arr.filter((p) => p._id !== programId);
const getCategoriesId = (arr) => arr.map((p) => p._id);

class ManageCategoriesModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    const { programs, restOfPrograms, category, newCategory, storeType } =
      props;
    const itemsUncategorized =
      programs.filter(
        (program) =>
          !program.category &&
          ((storeType === "programs" && !program.storeType) ||
            program.storeType === storeType)
      ) ?? [];
    this.state = {
      category: newCategory ? "" : category,
      itemsFromCategory:
        programs.filter(
          (program) =>
            program.category === category &&
            ((storeType === "programs" && !program.storeType) ||
              program.storeType === storeType)
        ) ?? [],
      itemsUncategorized,
      filteredUncategorized: itemsUncategorized,
      editing: false,
      search: "",
    };
    this.addProgramToCategory = this.addProgramToCategory.bind(this);
    this.removeProgramFromCategory = this.removeProgramFromCategory.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    const { search, itemsUncategorized } = this.state;
    if (
      prevState.search !== search ||
      prevState.itemsUncategorized.length !== itemsUncategorized.length
    ) {
      if (search === "") {
        return this.setState({
          filteredUncategorized: itemsUncategorized,
        });
      }
      this.setState({
        filteredUncategorized: itemsUncategorized.filter((program) =>
          program.name.toLowerCase().includes(search.toLowerCase())
        ),
      });
    }
  }

  addProgramToCategory(program) {
    const { itemsFromCategory, itemsUncategorized } = this.state;

    const newItemsFromCategory = [...itemsFromCategory, program];

    const newItemsUncategorized = filterCategories(
      itemsUncategorized,
      program._id
    );

    this.setState({
      itemsFromCategory: newItemsFromCategory,
      itemsUncategorized: newItemsUncategorized,
    });
  }

  removeProgramFromCategory(program) {
    const { itemsFromCategory, itemsUncategorized } = this.state;
    const newItemsFromCategory = filterCategories(
      itemsFromCategory,
      program._id
    );
    const newItemsUncategorized = [...itemsUncategorized, program];

    this.setState({
      itemsFromCategory: newItemsFromCategory,
      itemsUncategorized: newItemsUncategorized,
    });
  }

  saveChanges() {
    const { itemsFromCategory, itemsUncategorized, category } = this.state;
    const {
      newCategory,
      onSave,
      selectedCategoryId,
      selectedCategoryIndex,
      entity = "Programs",
      product,
      restOfPrograms,
    } = this.props;
    if (entity === "Programs") {
      //! Programs (Store)
      const programsToRemoveCategory = getCategoriesId(itemsUncategorized);
      const programsToAddCategory = getCategoriesId(itemsFromCategory);
      const restOfProgramsToAddCategory = getCategoriesId(
        restOfPrograms.filter((p) => p.category === this.props.category)
      );
      const dataToSend = {
        programsToRemoveCategory,
        programsToAddCategory: [
          ...programsToAddCategory,
          ...restOfProgramsToAddCategory,
        ],
        categoryName: category,
        categoryIndex: selectedCategoryIndex,
        newCategory,
      };

      onSave(newCategory ? null : selectedCategoryIndex, category);

      submit(`/actions/cycle/store/manage-category`, {
        method: "POST",
        body: dataToSend,
      });
      return;
    }

    if (entity === "Topics") {
      // ! Topics (Tutorials)
      const dataToSend = {
        category,
        newCategory,
        product,
        itemsFromCategory,
        itemsUncategorized,
        categoryId: selectedCategoryId,
      };
      if (!newCategory) {
        Object.assign(dataToSend, {
          categoryIndex: selectedCategoryIndex,
        });
      }
      onSave(newCategory ? null : selectedCategoryIndex, category);
      submit(`/actions/admin-panel/manage-category`, {
        method: "POST",
        body: dataToSend,
      });
      return;
    }
  }

  render() {
    const {
      itemsFromCategory,
      itemsUncategorized,
      category,
      editing,
      search,
      filteredUncategorized,
    } = this.state;
    const { newCategory, entity = "Programs", storeType } = this.props;

    const nameToDisplay = storeType === "programs" ? entity : "Single Workouts";

    return (
      <form id="add-exercise">
        <Modal
          className="manage-group categories"
          canClose={true}
          title={`${
            newCategory ? "Create New Category" : "Edit Category Settings"
          }`}
        >
          <div className="body">
            <form>
              <label>Name of Category</label>
              <input
                type="text"
                value={category}
                className="text-input"
                onChange={(evt) =>
                  this.setState({
                    category: evt.target.value,
                  })
                }
              />
            </form>

            {!newCategory ? (
              <>
                {itemsFromCategory.length || itemsUncategorized.length ? (
                  <div className="divider dividerr"></div>
                ) : null}
                <div className="members-list">
                  <header>
                    <p className="s1">
                      Selected {nameToDisplay} ({itemsFromCategory.length})
                    </p>
                  </header>
                  <ul className="tag-containerx">
                    {itemsFromCategory.map((item, idx) => (
                      <li className="tag-item" key={idx}>
                        <span>{item.name}</span>

                        <SvgIcon
                          onClickFn={() => this.removeProgramFromCategory(item)}
                          src="/img/new-icons/cross.svg"
                          role="button"
                          data-button-type="text-white"
                          data-icon-only="true"
                        />
                      </li>
                    ))}
                  </ul>
                </div>
                <div className="members-list unselected">
                  <header>
                    {editing ? (
                      <>
                        <input
                          type="search"
                          value={search}
                          onChange={(e) =>
                            this.setState({ search: e.target.value })
                          }
                          placeholder="Search..."
                        />
                        <SvgIcon
                          role="button"
                          data-button-type="text-white"
                          data-icon-only="true"
                          data-icon
                          sz="small"
                          onClickFn={() => {
                            this.setState({ search: "", editing: false });
                          }}
                          src="/img/new-icons/close-search.svg"
                        />
                      </>
                    ) : (
                      <p
                        className="s1"
                        onClick={() => this.setState({ editing: !editing })}
                      >
                        {itemsUncategorized.length
                          ? `Available ${nameToDisplay} (${itemsUncategorized.length})`
                          : `No available ${nameToDisplay}`}
                      </p>
                    )}
                  </header>
                  <ul>
                    {filteredUncategorized.map((item, idx) => (
                      <li className="program-item" key={idx}>
                        <span>{item.name}</span>
                        <SvgIcon
                          role="button"
                          data-button-type="text-white"
                          data-icon-only="true"
                          classNames="force-mobile-hidden"
                          onClick={() => this.addProgramToCategory(item)}
                          src="/img/new-icons/add.svg"
                        />
                      </li>
                    ))}
                  </ul>
                </div>
              </>
            ) : null}
          </div>
          <footer>
            <button
              data-button-type="primary"
              onClick={() => this.saveChanges()}
            >
              {newCategory ? "Add Category" : "Save Changes"}
            </button>
          </footer>
        </Modal>
      </form>
    );
  }
}

export default ManageCategoriesModal;
